<div class="control-header d-flex flex-row align-items-center justify-content-between">
  <div class="label">{{ 'word.remarks' | translate }}</div>
  <div class="operator">
    <ng-container *ngIf="mode === 'view'">
      <span class="operator-item"
            (click)="mode = 'edit'">{{ (note ? 'word.modify' : 'word.add_remark') | translate }}</span>
    </ng-container>

    <ng-container *ngIf="mode === 'edit'">
      <span class="operator-item" (click)="onCancel()">{{ 'word.cancel' | translate }}</span>
      <span class="operator-item" (click)="onConfirm()">{{ 'word.save' | translate }}</span>
    </ng-container>
  </div>
</div>

<div
  class="control-content d-flex flex-row"
  [class.align-items-start]="mode === 'edit'"
  [formGroup]="form"
  *ngIf="note || mode === 'edit'">
  <div class="label">{{ 'order.remarks_content' | translate }}</div>
  <div class="remark">
    <span *ngIf="note && mode === 'view'">{{ note }}</span>
    <textarea
      *ngIf="mode === 'edit'"
      formControlName="note"
      [placeholder]="'placeholder.order_remarks' | translate"
      nz-input
      rows="3"
    ></textarea>
  </div>
</div>
